import { render, staticRenderFns } from "./PrintingGroupListItem.vue?vue&type=template&id=a8d1f57c&scoped=true&"
import script from "./PrintingGroupListItem.vue?vue&type=script&lang=js&"
export * from "./PrintingGroupListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d1f57c",
  null
  
)

export default component.exports